/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useState } from 'react';
import TableSelect from 'ui/TableInputs/TableSelect/TableSelect';
import TableInput from 'ui/TableInputs/TableInput/TableInput';
import TableFiltersWrapper from 'ui/TableInputs/TableFiltersWrapper/TableFiltersWrapper';
import TableDatePicker from 'ui/TableInputs/TableDatePicker/TableDatePicker';
import { SelectItem } from 'ui/Input';
import { IFieldData, ITransactionReportSearchParams, TransactionType } from './TransactionReport.model';

const CategoryList: IFieldData[] = [
  {
    label: 'ALL',
    value: 'ALL',
  },
  {
    label: 'Successful',
    value: 'SUCCESSFUL',
  },
  {
    label: 'Failed',
    value: 'FAILED',
  },
  {
    label: 'Pending',
    value: 'PENDING',
  },
];

interface ITransactionReportFilterFields {
  onSubmitFilters: (values: ITransactionReportSearchParams) => void;
  submitting: boolean;
  activeMainTab: number | boolean;
  activeInnerTab: number | boolean;
  transactionType: TransactionType
}

const initialValues: ITransactionReportSearchParams = {
  reportCategory: '',
  ScheduleId: '',
  startDate: null,
  endDate: null,
};

const TransactionReportFilter = ({ submitting,
  onSubmitFilters, activeMainTab, activeInnerTab, transactionType }: ITransactionReportFilterFields) => {
  const [state, setState] = useState<ITransactionReportSearchParams>(initialValues);

  // useEffect(() => {
  //   setState(initialValues);
  // }, [activeMainTab, activeInnerTab]);

  const updateState = (update: Partial<ITransactionReportSearchParams>) =>
    setState((current) => ({ ...current, ...update }));

  const handleClearInput = (name: string) => () => {
    updateState({ [name as keyof ITransactionReportSearchParams]: '' });
  };

  const handleFilterChange = (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    const { name, value } = e.target;
    return updateState({ [name as keyof ITransactionReportSearchParams]: String(value) });
  };

  const dateFilterChange = (name: string, value?: string | null | undefined) => {
    if (value === 'Invalid date') {
      updateState({ [name as keyof ITransactionReportSearchParams]: null });
      return;
    }
    updateState({ [name as keyof ITransactionReportSearchParams]: value });
  };

  const handleClearDateInput = (name: string) => {
    updateState({ [name as keyof ITransactionReportSearchParams]: null });
  };

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmitFilters(state);
  };

  return (
    <>
      <form onSubmit={handleOnSubmit}>
        <TableFiltersWrapper btnText="Apply filters" submitting={submitting}>
          <TableSelect
            name="reportCategory"
            label="Report Category"
            onClickClear={handleClearInput('reportCategory')}
            value={state.reportCategory}
            fullWidth
            onChange={handleFilterChange}
            autoComplete="off"
            disabled={submitting}
          >
            {CategoryList.map(({ label, value }) => (
              <SelectItem key={label} value={value}>
                {label}
              </SelectItem>
            ))}
          </TableSelect>
          <TableInput
            name="ScheduleId"
            label={transactionType.includes('BULK') ? 'Bulk ID' : 'Schedule ID'}
            onClickClear={handleClearInput('ScheduleId')}
            value={state.ScheduleId}
            fullWidth
            onChange={handleFilterChange}
            autoComplete="off"
            disabled={submitting}
          />
          <TableDatePicker
            name="startDate"
            label="Start Date"
            onChange={dateFilterChange}
            onClickClear={handleClearDateInput}
            disabled={submitting}
          />
          <TableDatePicker
            name="endDate"
            label="End Date"
            onChange={dateFilterChange}
            onClickClear={handleClearDateInput}
            disabled={submitting}
          />
        </TableFiltersWrapper>
      </form>
    </>
  );
};

export default TransactionReportFilter;
